export default __webpack_public_path__ + "static/media/breakfastKeto.a0124f3a.svg";